// Static HTML shell takes over via public/index.html.
// This React app intentionally renders nothing so it does not interfere
// with the Hornlink Limited static site layout.
function App() {
  return null;
}

export default App;
